const COMMON_EMAIL_DOMAIN_CORRECTIONS: Readonly<Record<string, string>> = {
  "gmial.com": "gmail.com",
  "gamil.com": "gmail.com",
  "gmai.com": "gmail.com",
  "gmail.co": "gmail.com",
  "gmail.con": "gmail.com",
  "gmail.om": "gmail.com",
  gmailcom: "gmail.com",
  "gmaill.com": "gmail.com",
  "gmail.cim": "gmail.com",
  "gmail.com.com": "gmail.com",
  "googlemail.con": "googlemail.com",
  "outlok.com": "outlook.com",
  "outllook.com": "outlook.com",
  "outlook.con": "outlook.com",
  "outlook.co": "outlook.com",
  "hotmal.com": "hotmail.com",
  "hotmai.com": "hotmail.com",
  "hotmial.com": "hotmail.com",
  "hotmail.con": "hotmail.com",
  "live.con": "live.com",
  "yaho.com": "yahoo.com",
  "yahooo.com": "yahoo.com",
  "yahoo.con": "yahoo.com",
  "yahoo.co": "yahoo.com",
  "yahoomail.com": "yahoo.com",
  "yhoo.com": "yahoo.com",
};

/** Returns a corrected email for known provider-domain typos, otherwise null. */
export function getEmailTypoSuggestion(email: string): string | null {
  const normalizedEmail = email.trim();
  const atIndex = normalizedEmail.lastIndexOf("@");

  if (atIndex <= 0 || atIndex === normalizedEmail.length - 1) return null;

  const localPart = normalizedEmail.slice(0, atIndex);
  const domain = normalizedEmail.slice(atIndex + 1).toLowerCase();
  const correctedDomain =
    COMMON_EMAIL_DOMAIN_CORRECTIONS[domain] ||
    (domain.endsWith(".con") ? `${domain.slice(0, -4)}.com` : null);

  return correctedDomain ? `${localPart}@${correctedDomain}` : null;
}
